import { LicenseModel } from './createLicenseModel';

const statusOrder: Record<LicenseModel['status'], number> = {
  active: 0,
  expired: 1,
};

export type SortLicenseModel = Pick<LicenseModel, 'status' | 'creationDate'>;

export const sortLicenseModelFn = (itemA: SortLicenseModel, itemB: SortLicenseModel): number => {
  if (itemA.status !== itemB.status) {
    return statusOrder[itemA.status] - statusOrder[itemB.status];
  }
  return itemB.creationDate.toMillis() - itemA.creationDate.toMillis();
};
